import { composeModules, type LoadModuleData } from 'holocron';
import { addErrorToReport, loadLanguagePack } from '@americanexpress/one-app-ducks';
import { ADS_MODULE_NAME, MODULE_NAME } from '../constants/moduleConstants';
import { TravelPersonalizedMarketingArticlesProps } from '../types/PersonalizedMarketingArticles';
import { loadArticles } from './loadArticles';

export const loadModuleData: LoadModuleData<TravelPersonalizedMarketingArticlesProps> = async ({
  ownProps: {
    clientId = '',
    placementId = '',
  } = {},
  store: { dispatch },
}) => {
  try {
    const resolution = await Promise.allSettled([
      dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' })),
      dispatch(composeModules([
        { name: ADS_MODULE_NAME },
      ])),
      dispatch(loadArticles({ clientId, placementId })),
    ]);

    await Promise.all(resolution.filter((result) => result.status === 'rejected')
      .map(async (result) => {
        console.error('rejected', result);
        dispatch(addErrorToReport(result.reason, {
          collectionMethod: 'loadModuleData rejected',
          moduleID: MODULE_NAME,
          caught: true,
        }));
      }));
  } catch (e: unknown) {
    console.error('loadModuleData error', e);
    dispatch(addErrorToReport(e as Error, {
      collectionMethod: 'loadModuleData error',
      moduleID: MODULE_NAME,
      caught: false,
    }));
  }
};
